import React from 'react';
import QuestionContent from './QuestionContent';
import { Question } from './QuestionItem';
import './QuestionCard.css';

export interface QuestionCardProps {
    pageId: string;
    chapterId: string;
    index: number;
    content?: string;
    questions: Question[];
    isExpanded: boolean;
    onToggle: (pageId: string) => void;
}

const QuestionCard: React.FC<QuestionCardProps> = ({
    pageId,
    chapterId,
    index,
    content,
    questions,
    isExpanded,
    onToggle
}) => {
    return (
        <div className={`question-card rounded-card ${isExpanded ? 'expanded' : ''}`}>
            <div className="question-header">
                <div>
                    <h3 className="question-title">Chapter {chapterId} - Page {pageId}</h3>
                    <div className="question-meta">
                        <span className="content-badge">Question {index + 1}</span>
                        <span className="question-count">{questions.length} questions</span>
                    </div>
                </div>
                <button 
                    className="question-toggle" 
                    onClick={() => onToggle(pageId)}
                >
                    {isExpanded ? 'Hide' : 'Show'}
                    <span className="question-toggle-icon">▼</span>
                </button>
            </div>

            {content && (
                <div className="question-content">
                    {content}
                </div>
            )}

            {isExpanded && (
                <QuestionContent content={content} questions={questions} />
            )}
        </div>
    );
};

export default QuestionCard; 